import React from "react";
import { InitialPloca } from "./icons/InitialPloca";
import { InitialNoge } from "./icons/InitialNoge";
import { InitialSve } from "./icons/InitialSve";

export const TypeSelect = ({
  isActive,
  setActiveProduct,
  activeProduct,
  setNextStep,
  setShape,
  setPrice,
  setLegPrice,
}) => {
  return (
    isActive && (
      <div className="configurator-initial">
        <div className="configurator-initial__content">
          <h2 className="marcellus-40-400">Izaberite predmet</h2>
          <div className="configurator-initial__items poppins-18-500">
            <div
              className="configurator-initial__item"
              onClick={() => {
                setActiveProduct({ name: "legs" });
                setPrice(0);
                setLegPrice(0);
              }}
            >
              <InitialPloca />
              <div
                className={`configurator-initial__item-button ${
                  activeProduct && activeProduct.name == "legs" ? "active" : ""
                }`}
              >
                Samo noge
              </div>
            </div>
            <div
              className="configurator-initial__item"
              onClick={() => {
                setActiveProduct({ name: "board" });
                setPrice(0);
                setLegPrice(0);
              }}
            >
              <InitialNoge />
              <div
                className={`configurator-initial__item-button ${
                  activeProduct && activeProduct.name == "board" ? "active" : ""
                }`}
              >
                Samo ploča
              </div>
            </div>
            <div
              className="configurator-initial__item"
              onClick={() => {
                setActiveProduct({ name: "full" });
                setPrice(0);
                setLegPrice(0);
              }}
            >
              <InitialSve />
              <div
                className={`configurator-initial__item-button ${
                  activeProduct && activeProduct.name == "full" ? "active" : ""
                }`}
              >
                Komplet sto (ploča i noge)
              </div>
            </div>
          </div>
          {activeProduct && activeProduct.name && (
            <button
              type="button"
              onClick={() => {
                setNextStep();
                setShape(true);
              }}
              className="configurator-initial__btn btn green"
            >
              Nastavi
            </button>
          )}
        </div>
      </div>
    )
  );
};
